import React from 'react'
import PageBlocks from '../cms-page-blocks/list'

const WritingChallengeBlockEditor = (props) => {
  return (
    <PageBlocks
      title='14-Day Writing Challenge Sale Page Blocks'
      target='cms_fixed_page_blocks'
      cmsPageProp='page'
      cmsPageId='writing_challenge'
      route={props.route}
    />
  )
}

export default WritingChallengeBlockEditor
